import * as _ from 'underscore';
import { IListAndFieldValuesResource } from '../resources/Resource';
import { ContentFilterKeyName, IContentFilters } from './ContentFilters';
import { IContentType } from './ContentTypes';

// All the different place names across the app are represented by this type, to help make sure they're unique
export type PlaceName = 'task' | 'flow';

export interface IPlace {
  name: PlaceName;
  subplace(name: string): ISubplace<any>;
}

export interface ISubplace<T> {
  name: string;
  type: IContentType;
  resource: IListAndFieldValuesResource<T>;
  defaultFilters: _.Dictionary<string>;
  filterKeys(): ContentFilterKeyName[];
}

export class Place implements IPlace {

  private subplaceMap: _.Dictionary<ISubplace<any>>;
  private subplaceList: ISubplace<any>[];

  constructor(public name: PlaceName) {
    this.subplaceMap = {};
    this.subplaceList = [];
  }

  public subplace(name: string): ISubplace<any> {
    return this.subplaceMap[name];
  }

  public addSubplace(subplace: ISubplace<any>) {
    this.subplaceMap[subplace.name] = subplace;
    this.subplaceList.push(subplace);
  }

}

export class Subplace<T> implements ISubplace<T> {

  constructor(
    public  name: string,
    public  type: IContentType,
    public  resource: IListAndFieldValuesResource<T>,
    public  defaultFilters: Partial<IContentFilters<string>>,
    private excludeFilters: ContentFilterKeyName[] = []
  ) { }

  public filterKeys(): ContentFilterKeyName[] {
    return _.difference(this.type.filterKeys, this.excludeFilters);
  }

  // TODO: refactor this method to use QueryService
  public static create<T>(
      name: string,
      type: IContentType,
      resource: IListAndFieldValuesResource<T>,
      defaultFilters: Partial<IContentFilters<string>> = {},
      excludeFilters: ContentFilterKeyName[] = []
  ) {

    return new Subplace<T>(
      name,
      type,
      resource,
      defaultFilters,
      excludeFilters
    );
  }

}
